import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthLayoutComponent } from './layouts/auth-layout/auth-layout.component';
import { isNotLoggedGuard } from './core/guards/is-not-logged/is-not-logged.guard';
import { AppLayoutComponent } from './layouts/app-layout/app-layout.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: '',
    canActivate: [isNotLoggedGuard],
    component: AuthLayoutComponent,
    loadChildren: () => import(
      './modules/auth/auth.module'
    ).then(m => m.AuthModule)
  },
  {
    path: 'app',
    component: AppLayoutComponent,
    loadChildren: () => import(
      './modules/app-guard/app-guard.module'
    ).then(m => m.AppGuardModule)
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
